import { render, staticRenderFns } from "./KeyThree.vue?vue&type=template&id=0b913745&scoped=true&"
import script from "./KeyThree.vue?vue&type=script&lang=js&"
export * from "./KeyThree.vue?vue&type=script&lang=js&"
import style0 from "./KeyThree.vue?vue&type=style&index=0&id=0b913745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b913745",
  null
  
)

export default component.exports